module.exports = __webpack_public_path__ + "img/2.3089ba45.png";